// src/lib/opportunity/formatDocumentSlotClient.ts

import { opportunityFetch } from "./opportunityFetch.js";
import type { OpportunityFormatKey } from "../../types/opportunity.js";
import type { FormatDocumentSlot } from "./formatDocumentSlotTypes.js";

export function listFormatDocumentSlots(filters: {
  format_key: OpportunityFormatKey;
  product_type: string;
}) {
  const q = new URLSearchParams({
    format_key: filters.format_key,
    product_type: filters.product_type,
  });
  return opportunityFetch<{ ok: true; slots: FormatDocumentSlot[] }>(
    `/api/opportunity/format-document-slot-list?${q.toString()}`,
    { method: "GET" },
  );
}

export type UpsertFormatDocumentSlotPayload = {
  id?: string;
  format_key: OpportunityFormatKey;
  product_type: string;
  slot_key: string;
  label: string;
  helper_text: string | null;
  sort_order: number;
  required_before_signed?: boolean;
};

export function upsertFormatDocumentSlot(payload: UpsertFormatDocumentSlotPayload) {
  return opportunityFetch<{ ok: true; slot: FormatDocumentSlot }>(
    "/api/opportunity/format-document-slot-upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function deleteFormatDocumentSlot(id: string) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/format-document-slot-delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id }),
  });
}

export function reorderFormatDocumentSlots(payload: {
  format_key: OpportunityFormatKey;
  product_type: string;
  ordered_ids: string[];
}) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/format-document-slot-reorder", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
